import React from "react";
import TextField from "@mui/material/TextField";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
import { useIntl } from "react-intl";

const DetailsSection = ({
  touched,
  errors,
  values,
  handleChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <DocumentLayout>
      <TextField
        sx={{ mb: 2 }}
        error={
          touched && errors && touched.subject && errors.subject ? true : false
        }
        label={formatMessage({ id: "ticket.create.detail.subject" })}
        id="subject"
        name="subject"
        value={values.subject}
        fullWidth
        onChange={handleChange}
        autoFocus
        helperText={
          touched &&
          errors &&
          touched.subject &&
          errors.subject &&
          formatMessage({
            id: "ticket.create.detail.error.wrong_subject",
          })
        }
      />

      <TextField
        sx={{ mb: 2 }}
        label={formatMessage({ id: "ticket.create.detail.place" })}
        error={
          touched && errors && touched.place && errors.place ? true : false
        }
        id="place"
        name="place"
        fullWidth
        value={values.place}
        onChange={handleChange}
        helperText={
          touched &&
          errors &&
          touched.place &&
          errors.place &&
          formatMessage({
            id: "ticket.create.detail.error.invalid_place",
          })
        }
      />

      <TextField
        sx={{ mb: 2 }}
        error={touched && errors && touched.body && errors.body ? true : false}
        label={formatMessage({ id: "ticket.create.detail.details" })}
        id="body"
        name="body"
        value={values.body}
        multiline
        rows="4"
        fullWidth
        onChange={handleChange}
        helperText={
          touched &&
          errors &&
          touched.body &&
          errors.body &&
          formatMessage({
            id: "ticket.create.detail.error.invalid_description",
          })
        }
      />
    </DocumentLayout>
  );
};

export default DetailsSection;
